// import dataScreenList from '../components/dataScreen/dataScreenList.vue' 
export default [
    {
        path: 'dataScreen/dataScreenList',
        component:  resolve => require(['@/components/dataScreen/dataScreenList'],resolve),
        name:'DataScreenList',
        meta:{
            // id:'237',
            node:'dataScreen',
            url:'dataScreenList',
        }
    },
    
]


// WEBPACK FOOTER //
// ./src/router/dataScreen.js